export function getdata(){
	var obj = {
		
			headDataI:[
				{
					title: "序号",
					prop: "xh",
					width:"50px",
					custom:true,
				},
				{
					title: "抵减项目",
					prop: "djxm",
					width:"196px",
					custom:true,
				},
				{
					title: "期初余额",
					prop: "",
					width:"",
					children:[
						{
							title: "1",
							prop: "zzs_4_x_1",
							custom:true,
						}
					],
					custom:true,
				},
				{
					title: "本期发生额",
					prop: "",
					children:[
						{
							title: "2",
							prop: "zzs_4_x_2",
							custom:true,
						}
					],
					custom:true,
				},
				{
					title: "本期应抵减税额",
					prop: "",
					children:[
						{
							title: "3=1+2",
							prop: "zzs_4_x_3",
							custom:true,
						}
					],
					custom:true,
				},
				{
					title: "本期实际抵减税额",
					prop: "",
					children:[
						{
							title: "4≤3",
							prop: "zzs_4_x_4",
							custom:true,
						}
					],
					custom:true,
				},
				{
					title: "期末余额",
					prop: "",
					children:[
						{
							title: "5=3-4",
							prop: "zzs_4_x_5",
							custom:true,
							width:"200px"
						}
					],
					custom:true,
				},
			],
			tableDataI:[
				{
					xh:"1",
					djxm:"增值税税控系统专用设备费及技术维护费",
					disabledzzs_4_x_3:true,
					disabledzzs_4_x_5:true
				},
				{
					xh:"2",
					djxm:"分支机构预征缴纳税款",
					disabledzzs_4_x_3:true,
					disabledzzs_4_x_5:true
				},
				{
					xh:"3",
					djxm:"建筑服务预征缴纳税款",
					disabledzzs_4_x_3:true,
					disabledzzs_4_x_5:true
				},
				{
					xh:"4",
					djxm:"销售不动产预征缴纳税款",
					disabledzzs_4_x_3:true,
					disabledzzs_4_x_5:true
				},
				{
					xh:"5",
					djxm:"出租不动产预征缴纳税款",
					disabledzzs_4_x_3:true,
					disabledzzs_4_x_5:true
				}
			],
			headDataII:[
				{
					title: "序号",
					prop: "xh",
					width:"50px",
					custom:true,
				},
				{
					title: "加计抵减项目",
					prop: "djxm",
					width:"196px",
					custom:true,
				},
				{
					title: "期初余额",
					prop: "",
					width:"",
					children:[
						{
							title: "1",
							prop: "zzs_4_x_1",
							custom:true,
						}
					],
					custom:true,
				},
				{
					title: "本期发生额",
					prop: "",
					children:[
						{
							title: "2",
							prop: "zzs_4_x_2",
							custom:true,
						}
					],
					custom:true,
				},
				{
					title: "本期调减额",
					prop: "",
					children:[
						{
							title: "3",
							prop: "zzs_4_x_3",
							custom:true,
						}
					],
					custom:true,
				},
				{
					title: "本期可抵减额",
					prop: "",
					children:[
						{
							title: "4=1+2-3",
							prop: "zzs_4_x_4",
							custom:true,
						}
					],
					custom:true,
				},
				{
					title: "本期实际抵减额",
					prop: "",
					children:[
						{
							title: "5",
							prop: "zzs_4_x_5",
							custom:true,
							width:"100px",
						}
					],
					custom:true,
				},
				{
					title: "期末余额",
					prop: "",
					children:[
						{
							title: "6=4-5",
							prop: "zzs_4_x_6",
							custom:true,
							width:"100px"
						}
					],
					custom:true,
				}
			],
			tableDataII:[
				{
					xh:"6",
					djxm:"一般项目加计抵减额计算",
					disabledzzs_4_x_1:true,
					disabledzzs_4_x_4:true,
					disabledzzs_4_x_6:true
				},
				{
					xh:"7",
					djxm:"即征即退项目加计抵减额计算",
					disabledzzs_4_x_1:true,
					disabledzzs_4_x_4:true,
					disabledzzs_4_x_6:true
				},
				{
					xh:"8",
					djxm:"合计",
					disabledzzs_4_x_1:true,
					disabledzzs_4_x_2:true,
					disabledzzs_4_x_3:true,
					disabledzzs_4_x_4:true,
					disabledzzs_4_x_5:true,
					disabledzzs_4_x_6:true,
				}
			],
		
	}
	return obj
}
